<template>
  <div class="order-details-card">
    <div class="title">
      <span>借款额度(元)</span>
      <span class="span">{{ amountFormatter(orderDetails.borrowAmount) }}</span>
    </div>
    <!--借款期限：-->
    <div class="term-wrap">
      <div class="term-item border-right">
        <span class="term-label">年利率</span>
        <span class="span">{{ orderDetails.annualizedRatio }}%</span>
      </div>
      <div class="term-item border-right">
        <span class="term-label">分期期数</span>
        <span class="span">{{ orderDetails.issueOrderNum }}</span>
      </div>
      <div class="term-item">
        <span class="term-label">每期天数</span>
        <span class="span">{{ orderDetails.issueDay }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { amountFormatter } from "@/utils/utils";

export default {
  name: "orderDetailsCard",
  data() {
    return {
      amountFormatter,
    };
  },
  async mounted() {},
  methods: {},
  computed: {
    orderDetails() {
      return this.$store.getters.orderDetails;
    },
  },
};
</script>

<style scoped lang="scss">
.order-details-card {
  padding: 20px 10px;
  background-image: url("@/assets/style/details-icon.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.title {
  display: flex;
  align-items: center;
  color: #fff;
  justify-content: space-between;
  flex-direction: column;
  .span {
    font-weight: 500;
    font-size: 46px;
    margin-top: 8px;
  }
}
.interest-wrap {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  font-size: 14px;
  padding: 10px 0px;
  color: #0079b5;
}
.term-wrap {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  font-size: 16px;
  padding-top: 20px;
  .term-item {
    display: flex;
    align-items: center;
    flex-direction: column;
    color: rgba(255,255,255,0.6);
    font-size: 15px;
    width: 32%;
    .span {
      font-weight: 500;
      font-size: 18px;
      color: #fff;
    }
  }
  .border-right{
    border-right: solid 1px #5795fa;
  }
}
</style>
